import { registryINP } from '@ks-dmo/inp-reporter';
import Radar from '@ks-radar/radar';
import { Weblog } from '@ks/weblogger/lib/log.browser';
import AutoPV from '@ks/weblogger/lib/plugins/autopv';

import { getCookie } from './cookie';

export const radarIns = new Radar({
  projectId: '12aa78adap', // 雷达项目ID
  sampling: 1,
  lcp: true,
  cls: true,
  fid: true,
  fcp: true,
  APIHook(apiData) {
    const { response } = apiData;
    try {
      const data = JSON.parse(response.data) as any;
      return {
        response_code: data.status,
        response_msg: data.message || '', // 业务定义的接口返回code的语义化解释 限制在100字符以内
        status: response?.status || 0,
        // custom_failed: 业务定义的api是否成功，api成功率依靠这个指标来进行判断。默认值为!(status >= 200 && status < 300)，boolean类型
      };
    } catch (_err) {
      return {
        status: response?.status || 0,
      };
    }
  },
});

export const initWeblogger = () => {
  try {
    // 初始化 weblogger
    const weblog = new Weblog(
      {
        env: 'oversea',
        plugins: [new AutoPV()],
        urlMap: ({ url, page, params }) => {
          // 根据路由路径映射为页面标识
          const pathname = new URL(url || '').pathname;
          let mappedPage = page;

          if (pathname.startsWith('/download')) {
            mappedPage = 'DOWNLOAD';
          } else if (pathname === '/login' || pathname === '/login-fail') {
            mappedPage = 'LOGIN';
          } else if (pathname === '/register') {
            mappedPage = 'REGISTER';
          } else if (pathname === '/forgot-password') {
            mappedPage = 'RESET_PASSWORD';
          } else if (pathname === '/') {
            mappedPage = 'HOME';
          }

          return {
            page: mappedPage,
            params,
          };
        },
      },
      {
        product_name: 'codeflicker_ide_web_oversea', // 产品标识
      },
    );

    // 将 weblog 实例绑定到 window 对象，供全局使用
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.webLoggerIns = weblog;

    radarIns.bindWeblogger(weblog);
    registryINP(radarIns);
  } catch (_e) {
    //
  }
};

/**
 * /**
  需要上报 fmp 的地方
  可以传入fmp结束的时间戳，如果不传默认是调用fmp时作为fmp结束时刻，内部自动计算出fmp耗时
  */
let hasReportedFMP = false;
export const collectFMP = (timestamp?: number) => {
  if (import.meta.env.DEV && !hasReportedFMP) {
    hasReportedFMP = true;
    // eslint-disable-next-line no-console
    console.log('FMP 指标：', performance.now());
  }
  radarIns?.fmp(timestamp);
};

/** 获取logger方法 */
function getLoggerMethod(method: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof window.webLoggerIns[method] === 'function') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window.webLoggerIns[method].bind(window.webLoggerIns);
  }
  return undefined;
}

/** 更新 common_package */
export const updateCommonPackage = (params: { [key: string]: string }) => {
  try {
    const updatePkg = getLoggerMethod('updateCommonPackage');
    updatePkg?.(params);
  } catch (e) {
    // do nothing
    console.error('something wrong in updateCommonPackage, the error is', e);
  }
};

/**
 * 安全地发送埋点数据
 * @param eventType 事件类型，如 'CLICK'
 * @param params 埋点参数
 */
export const sendWeblogEvent = (eventType: string, params: any) => {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.webLoggerIns?.sendImmediately(eventType, params);
  } catch (error) {
    console.error('埋点上报失败:', error);
  }
};

/**
 * 创建一个只能执行一次的函数（类似 lodash 的 once）
 * @param fn 要包装的函数
 * @returns 包装后的函数，只会执行一次
 */
function once<T extends (...args: any[]) => any>(fn: T): T {
  let called = false;
  let result: ReturnType<T>;

  return ((...args: Parameters<T>): ReturnType<T> => {
    if (!called) {
      called = true;
      result = fn(...args);
    }
    return result;
  }) as T;
}

/**
 * X Pixel 下载事件触发方法
 * @param type 平台类型
 * @param version 版本号
 */
function pixelDownloadEvent(type: string, version: string) {
  try {
    window?.twq('event', 'tw-qg6at-qg6aw', {
      contents: [
        {
          content_id: getCookie('_did'),
          content_type: type,
          content_name: version,
        },
      ],
      email_address: getCookie('_did'),
    });

    window?.twq('event', 'tw-qedc2-qedc5', {
      contents: [
        {
          content_id: getCookie('_did'),
          content_type: type,
          content_name: version,
        },
      ],
      email_address: getCookie('_did'),
    });

    window?.rdt('track', 'Purchase', {
      conversionId: getCookie('_did'),
      products: [{ id: '1', name: version, category: type }],
    });
  } catch (error) {
    console.error('X Pixel 事件触发失败:', error);
  }
}

// 使用 once 包装，确保只执行一次
const triggerDownloadPixelEvent = once(pixelDownloadEvent);

export function sendDownloadClickEvent(type: string, version: string, page: 'download' | 'home') {
  // 发送内部 weblog 事件（每次点击都会发送）
  sendWeblogEvent('CLICK', {
    action: 'DOWNLOAD_CLICK',
    params: {
      platform: type,
      version: version,
      page: 'download',
      referer: document.referrer,
    },
    page: page?.toUpperCase(),
  });

  // 触发 X Pixel 事件（单次访问只触发一次）
  triggerDownloadPixelEvent(type, version);
}
